"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TempSummaryList = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _row = _interopRequireDefault(require("../row"));

var _col = _interopRequireDefault(require("../col"));

var _card = require("../card");

var _table = _interopRequireDefault(require("../table"));

require("./index.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Node
// ShpmtcDesign Components
// Style
var TempSummaryList = function TempSummaryList(_ref) {
  var header = _ref.header,
      infoList = _ref.infoList,
      summaryTable = _ref.summaryTable;
  return /*#__PURE__*/_react.default.createElement(_card.Card, {
    className: "temp-list-block"
  }, header ? /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "temp-list-block__content",
    type: "flex",
    align: "middle",
    gutter: 40
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: {
      span: 24,
      push: 0
    },
    sm: {
      span: 12,
      push: 12
    },
    className: "temp-list-block__content__right-list"
  }, header.logo), /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: 24,
    sm: 0
  }, /*#__PURE__*/_react.default.createElement("hr", {
    className: "row-spacing--md"
  })), /*#__PURE__*/_react.default.createElement(_col.default, {
    xs: {
      span: 24,
      pull: 0
    },
    sm: {
      span: 12,
      pull: 12
    },
    className: "temp-list-block__content__left-list"
  }, header.title)) : null, infoList ? /*#__PURE__*/_react.default.createElement(_row.default, {
    className: "temp-list-block__content",
    gutter: 40
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    sm: 12,
    className: "temp-list-block__content__left-list"
  }, infoList.leftList), /*#__PURE__*/_react.default.createElement(_col.default, {
    sm: 12,
    className: "temp-list-block__content__right-list"
  }, infoList.rightList)) : null, /*#__PURE__*/_react.default.createElement("hr", {
    className: "row-spacing--md"
  }), summaryTable ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_table.default, {
    className: "temp-list-block__table non-frame",
    columns: summaryTable.colums,
    dataSource: summaryTable.data,
    pagination: false,
    scroll: {
      x: 600
    }
  }), /*#__PURE__*/_react.default.createElement("section", {
    className: "temp-list-block__summary-block text-align--right"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "list-block"
  }, summaryTable.summaryList))) : null);
}; // Prop Types


exports.TempSummaryList = TempSummaryList;
TempSummaryList.defaultProps = {
  header: null,
  infoList: null,
  summaryTable: null
};
TempSummaryList.propTypes = {
  header: _propTypes.default.instanceOf(Object),
  infoList: _propTypes.default.instanceOf(Object),
  summaryTable: _propTypes.default.instanceOf(Object)
};